import { Box } from '@jfs/ui-new'
import { useState } from 'react'
import { Animated, Easing } from 'react-native'
import { SvgImage } from '../../comps/SvgImage'

export const StatusLoaderAnimation = () => {
  const [spiner] = useState<any>(new Animated.Value(0))

  Animated.loop(
    Animated.timing(spiner, {
      toValue: 1,
      useNativeDriver: false,
      duration: 2000,
      easing: Easing.linear,
      delay: 0,
    }),
  ).start()

  const spin = spiner.interpolate({
    inputRange: [0, 1],
    outputRange: ['0deg', '360deg'],
  })

  return (
    <Animated.View style={{ transform: [{ rotate: spin }] }}>
      <Box alignItems={'center'}>
        <SvgImage imageName={'StatusLoading'} />
      </Box>
    </Animated.View>
  )
}
